import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from './IsAuth.js';

const CheckAuth = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/" />
}

export default CheckAuth